module.exports = __webpack_public_path__ + "static/media/143.7baf77dd.png";